import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PublicRoute = () => {
  const { user, passwordResetInProgress } = useAuth();
  const location = useLocation();

  if (user) {
    // Redirigir automáticamente al inicio adecuado según el rol
    if (user.rol_id === 3) {
      return <Navigate to="/detalles" />;
    }
    return <Navigate to="/dashboard" />;
  }

  // Restringir el acceso a /reset-password si no está siguiendo el flujo correcto
  if (
    (location.pathname === "/reset-password" ||
      location.pathname === "/verify-otp") &&
    !passwordResetInProgress
  ) {
    return <Navigate to="/forgot-password" />;
  }

  return <Outlet />;
};

export default PublicRoute;
